import './Pixel.css';

import React from 'react';

function Pixel({ provider }: { provider: string }) {
  return <div className={`pixel icon ${provider}`} />;
}

export default Pixel;
